module.exports = __webpack_public_path__ + "static/media/ImporterFeature3.a668995c.svg";